export const toTitleCase = (str) =>
  str?.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) ?? '';

export const todayStr = () => new Date().toISOString().split('T')[0];

export const isToday = (dateStr) => dateStr === todayStr();

export function mapExportRow(f) {
  return {
    date: f.Date,
    started: f.Started,
    finished: f.Finished,
    filesExported: f['Files Exported'],
    exportPendingAwaiting: Number(f['Export Pending. Awaiting Meterdata / Infill'] || 0),
    errors: f.Errors,
  };
}


